export enum SweepError {
  ManagedPackageRequired = 'ManagedPackageRequired',
  ProductionEnvMissing = 'ProductionEnvMissing',
  CrmOrgNotFound = 'CrmOrgNotFound',
  OrgAccessTimeout = 'OrgAccessTimeout',
  CrmOrgBadCredentials = 'CrmOrgBadCredentials',
  UserNotConnected = 'UserNotConnected',
  SfdcUserBadCredentials = 'SfdcUserBadCredentials',
  SfdcUserNoCredentialsYet = 'SfdcUserNoCredentialsYet',
  NoFieldPermission = 'NoFieldPermission',
  HubspotNoCredentials = 'HubspotNoCredentials',
  CrmOrgInvalidGrant = 'CrmOrgInvalidGrant',
  CustomIntegrationInUse = 'CustomIntegrationInUse',
  RequestLimitExceededTotalRequests = 'RequestLimitExceededTotalRequests',
  RequestLimitExceededConcurrentRequests = 'RequestLimitExceededConcurrentRequests',
  InviteUserFailed = 'InviteUserFailed',
  OptimisticLockFailed = 'OptimisticLockFailed',
  AccountSelectionRequired = 'AccountSelectionRequired',
  CrmOrgAlreadyConnected = 'CrmOrgAlreadyConnected',
}
